import { BasePage } from '@/components/ui/base-page'

export function FarmlandsPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add FarmlandsPage specific content here */}
    </BasePage>
  )
}